<template>
    <v-card class="table-card">
        <v-card-title v-if="search" class="table-card__header">
            <v-spacer></v-spacer>
            <v-text-field
                    @input="onSearch"
                    v-model="searchText"
                    append-icon="search"
                    label="Поиск"
                    single-line
                    hide-details
                    class="table-card__header-input"
            >
            </v-text-field>
        </v-card-title>

        <v-data-table
                :headers="headerLines"
                :items="data"
                :search="searchText"
                :no-data-text="emptyText"
                :no-results-text="textNoResults"
                hide-actions
                @update:pagination="onUpdate"
                class="elevation-1 table-card__content">

            <template slot="items" slot-scope="{item, index}">
                <tr>
                    <td v-if="withIndex">{{ index + 1 }}</td>
                    <td v-for="(key, i) in keys" :key="'td' + i">{{ item[key] }}</td>
                </tr>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
    export default {
        name: 'interface-table',
        components: {},
        props: {
            withIndex: Boolean,
            headers: {
                type: Array,
                default: () => []
            },
            search: {
                type: Boolean,
                default: true
            },
            data: {
                type: Array,
                default: () => []
            }
        },
        data: () => ({
            searchText: '',
            emptyText: 'Данные отсутствуют'
        }),
        computed: {
            keys () {
                return this.headers.map(item => item.value)
            },
            textNoResults () {
                return `На ваш поиск "${this.searchText}" нет результатов`
            },
            headerLines () {
                if (this.withIndex) {
                    return [{
                        text: '№',
                        sortable: false
                    }].concat(this.headers)
                } else {
                    return this.headers
                }
            }
        },
        methods: {
            onSearch () {
                this.$emit('search', this.searchText)
            },
            onUpdate (data) {
                this.$emit('update', data)
            }
        }
    }
</script>

<style lang="stylus">
    .table-card {
        height 100% !important
        border-radius 0

        &__header {
            padding 2px 16px 3px
            background #c8c5c8
            border-bottom 1px solid #b4b4b4

            /deep/ .input-group--single-line input[type="text"] {
                height 100%
                cursor text
                font-size 14px
            }

            /deep/ .icon {
                font-size 18px
            }

            /deep/ .input-group__details::after {
                display none
            }

            /deep/ label,
            /deep/ .input-group__input {
                min-height 20px
                height 20px
                line-height 20px
                font-size 14px
            }

            &-input {
                padding-top 0

                &.input-group--text-field > label {
                    top auto
                }
            }
        }

        &__content {
            overflow auto
            height calc(100% - 28px)

            /deep/ table.table tbody td:first-child, table.table thead th.text-xs-left:first-child {
                text-align center !important
                padding: 0 5px
            }

            /deep/ table.table tbody td, table.table thead th {
                padding: 0 10px 0 20px
                height 30px
                outline none
                border 1px solid #c8c5c8
            }

            /deep/ table.table thead tr th {
                border none
                border-left 1px solid #c8c5c8
                border-right 1px solid #c8c5c8
            }

            /deep/ table.table thead tr {
                height 36px
                background rgba(0, 0, 0, .1)
                border none !important
            }
        }
    }
</style>
